/**
 * ClassName utility functions
 */

/**
 * Build a className string from an array of class names
 * Filters out falsy values and joins with spaces
 * @param classes - Array of class names (strings, booleans, or undefined)
 * @returns Joined className string
 */
export const buildClassName = (...classes: (string | boolean | null | undefined)[]): string => {
  return classes.filter(Boolean).join(' ');
};
